{
  "header": {
    "productMenu": {
      "car": "CAR"
    },
    "settingsMenu": {
      "systemSettings": "System Settings",
      "systemSettingsTooltip": "Click to open the system settings menu.",
      "switchRegion": "Switch region",
      "switchRegionTooltip": "Current region: {{region}}. Choose a different region."
    }
  },
  "systemInfoDialog": {
    "title": "System Information",
    "email": "Email",
    "tenant": "Tenant",
    "environment": "Environment",
    "unavailable": "Not available"
  },
  "regionPicker": {
    "logoAlt": "dTIMS",
    "title": "Choose your region",
    "hint": "Your data stays in the region you choose. You can switch later from the settings menu.",
    "optionsLegend": "Available regions",
    "suggestedLabel": "Suggested for your time zone",
    "documentTitle": "Choose your region",
    "bootErrorTitle": "dTIMS could not start",
    "backToRegionSelection": "Back to region selection"
  },
  "authCallback": {
    "logoAlt": "Deighton Logo",
    "completingSignIn": "Completing sign-in…",
    "exchangingCode": "Exchanging authorization code. Please do not close this tab.",
    "signInComplete": "Sign-in complete!",
    "redirecting": "Redirecting to your workspace…",
    "errorAriaLabel": "Error Status",
    "authFailed": "Authentication failed",
    "errorSubtext": "Please return to the login page and try again.",
    "showTechnicalDetails": "Show technical details",
    "technicalDetailsAriaLabel": "Technical error details",
    "retryAriaLabel": "Return to login page",
    "retryButton": "Back to sign-in",
    "processingCallback": "Processing callback…"
  }
}
